import { Download, File, Languages, MailOpen, Paperclip } from "lucide-react";
import { sanitizeEmailHtml } from "../../lib/sanitize";
import { Button } from "../../components/ui/Button";
import { EmptyState, ErrorState, LoadingState } from "../../components/ui/Feedback";

function Attachments({ attachments = [] }) {
  if (!attachments.length) return null;
  return (
    <section className="attachment-section">
      <header><Paperclip size={15} /><strong>附件</strong><small>{attachments.length} 个</small></header>
      <div>
        {attachments.map((item) => (
          <a key={item.id || item.name} href={item.url || `/api/mail-assets/${item.id}`} target="_blank" rel="noreferrer">
            <File size={16} /><span>{item.filename || item.name || "附件"}</span><Download size={14} />
          </a>
        ))}
      </div>
    </section>
  );
}

export default function EmailContent({
  inquiry,
  onOriginal,
  onTranslate,
  translating,
  bodyLoading = false,
  bodyError = "",
  onBodyRetry,
}) {
  const html = inquiry?.body_html ? sanitizeEmailHtml(inquiry.body_html) : "";
  const body = String(inquiry?.body_full_text || inquiry?.body || "").trim();
  const translation = String(inquiry?.body_translation || "").trim();
  const bodyPending = bodyLoading || Boolean(inquiry?.body_html_deferred);
  return (
    <section className="email-content">
      <header className="content-section-header">
        <div><h3>客户邮件</h3><small>本次客户来信原始格式、中文翻译与附件</small></div>
        <div className="content-section-actions">
          {!translation ? <Button size="sm" variant="ghost" icon={Languages} loading={translating} onClick={onTranslate}>生成中文翻译</Button> : null}
          <Button size="sm" variant="ghost" icon={MailOpen} onClick={onOriginal}>查看原始邮件</Button>
        </div>
      </header>
      <article className="email-paper">
        {html ? (
          <div className="email-html" dangerouslySetInnerHTML={{ __html: html }} />
        ) : body ? (
          <pre>{body}</pre>
        ) : bodyError ? (
          <ErrorState title="客户正文加载失败" message={bodyError} onRetry={onBodyRetry} />
        ) : bodyPending ? (
          <LoadingState label="正在加载客户完整正文…" />
        ) : (
          <EmptyState title="客户正文为空" description="原始邮件中也没有可显示的正文，可打开原始邮件进行校正。" />
        )}
      </article>
      {translation ? (
        <article className="translation-paper">
          <span>中文翻译</span>
          <pre>{translation.replace(/<\/?(?:email_subject|customer_original_text)>/gi, "").trim()}</pre>
        </article>
      ) : null}
      <Attachments attachments={inquiry?.attachments || []} />
    </section>
  );
}
